import React from 'react';
import PendingPage from '../../components/shared/Pending';
export default function AdminSupportTickets() { return <PendingPage title="Support tickets" description="Requests raised by hosts, customers and platform users." note="Support ticket endpoints are not yet exposed in the admin API." />; }
